import React from "react"

export interface IProps extends Omit<React.HTMLProps<HTMLImageElement>, "src"|"name"> {
  src?: string
  name?: string
}

const ImgIcon = ({ src, name, ...props }: IProps) => {
  return (
    <img src={src ?? `/icons/${name}`} {...props} />
  )
}

export default ImgIcon
